"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = exports.toggleTransform = exports.inStateContainer = exports.createProgressiveState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Utils = _interopRequireDefault(require("../../util/Utils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var mapNothing = function mapNothing() {
  return {};
};

var defaultGetPassedProps = function defaultGetPassedProps(props) {
  return props;
};

var containerGetPassedProps = function containerGetPassedProps(props) {
  return props.passedProps;
};

var createProgressiveState = function createProgressiveState(stateDefs) {
  return function (_ref) {
    var passedProps = _ref.passedProps,
        initialState = _ref.initialState,
        boundSetState = _ref.boundSetState,
        _ref$getPassedProps = _ref.getPassedProps,
        getPassedProps = _ref$getPassedProps === void 0 ? defaultGetPassedProps : _ref$getPassedProps;

    var isControlled = function isControlled(name) {
      return passedProps[name] === undefined;
    }; // figure out which props will be controlled and create initial state for those


    var pState = (0, _reduce.default)(stateDefs).call(stateDefs, function (state, _ref2) {
      var name = _ref2.name,
          initial = _ref2.initial;

      if (isControlled(name)) {
        return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty3.default)({}, name, initialState[name] === undefined ? initial : initialState[name]));
      }

      return state;
    }, {}); // make sure the keys provided in initialState are actually being controlled

    if (!_Utils.default.isProduction()) {
      var _context;

      (0, _forEach.default)(_context = (0, _keys.default)(initialState)).call(_context, function (key) {
        if (pState[key] === undefined) {
          console.warn("Initial state provided for prop \"".concat(key, "\" that is not being controlled by the component"));
        }
      });
    } // generate custom callbacks with transform functions


    var makeTransformCallbacks = function makeTransformCallbacks(name) {
      var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return (0, _reduce.default)(callbacks).call(callbacks, function (transformCallbacks, _ref3) {
        var cbName = _ref3.name,
            transform = _ref3.transform,
            _ref3$passTransformed = _ref3.passTransformedValue,
            passTransformedValue = _ref3$passTransformed === void 0 ? false : _ref3$passTransformed;
        return _objectSpread(_objectSpread({}, transformCallbacks), {}, (0, _defineProperty3.default)({}, cbName, function (value, e) {
          // set the state with the transformed value
          boundSetState(function (state, props) {
            var transformedValue = transform(value, state[name], getPassedProps(props));

            if (passedProps[cbName]) {
              passedProps[cbName](passTransformedValue ? transformedValue : value, e);
            }

            return (0, _defineProperty3.default)({}, name, transformedValue);
          });
        }));
      }, {});
    }; // get the callbacks for a single state definition


    var makeCallbacksFromDef = function makeCallbacksFromDef(_ref5) {
      var name = _ref5.name,
          setter = _ref5.setter,
          callbacks = _ref5.callbacks;
      // add any custom callbacks
      var customTransformCallbacks = makeTransformCallbacks(name, callbacks); // return with setter if defined

      return setter ? _objectSpread((0, _defineProperty3.default)({}, setter, function (value, e) {
        boundSetState((0, _defineProperty3.default)({}, name, value)); // if a callback is provided, we'll still execute it

        if (passedProps[setter]) {
          passedProps[setter](value, e);
        }
      }), customTransformCallbacks) : customTransformCallbacks;
    }; // create all the callbacks


    var pCallbacks = (0, _reduce.default)(stateDefs).call(stateDefs, function (returnCallbacks, def) {
      if (!isControlled(def.name)) {
        return returnCallbacks;
      }

      return _objectSpread(_objectSpread({}, returnCallbacks), makeCallbacksFromDef(def));
    }, {});
    return [pState, pCallbacks];
  };
};

exports.createProgressiveState = createProgressiveState;

var StateContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(StateContainer, _React$Component);

  var _super = _createSuper(StateContainer);

  function StateContainer(_ref6) {
    var _context2;

    var _this;

    var stateDefs = _ref6.stateDefs,
        initialState = _ref6.initialState,
        passedProps = _ref6.passedProps;
    (0, _classCallCheck2.default)(this, StateContainer);
    // the constructor has two main goals
    // 1) populate the state for any props that will be controlled
    // 2) create callback functions for those props
    _this = _super.call(this);

    var _createProgressiveSta = createProgressiveState(stateDefs)({
      initialState: initialState,
      passedProps: passedProps,
      boundSetState: (0, _bind.default)(_context2 = _this.setState).call(_context2, (0, _assertThisInitialized2.default)(_this)),
      getPassedProps: containerGetPassedProps
    }),
        _createProgressiveSta2 = (0, _slicedToArray2.default)(_createProgressiveSta, 2),
        state = _createProgressiveSta2[0],
        callbacks = _createProgressiveSta2[1];

    _this.state = state;
    _this.callbacks = callbacks;
    return _this;
  }

  (0, _createClass2.default)(StateContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mapToProps = _this$props.mapToProps,
          passedProps = _this$props.passedProps; // alert dev if there are state/prop conflicts

      if (!_Utils.default.isProduction()) {
        var _context3;

        (0, _forEach.default)(_context3 = (0, _keys.default)(this.state)).call(_context3, function (key) {
          if (passedProps[key] !== undefined) {
            console.warn("The prop \"".concat(key, "\" is being controlled by the component because it was not initially set. ") + "The newly-received value will be ignored.");
          }
        });
      }

      return children(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, passedProps), this.callbacks), this.state), mapToProps(this.state, passedProps)));
    }
  }]);
  return StateContainer;
}(_react.default.Component);

(0, _defineProperty3.default)(StateContainer, "propTypes", {
  stateDefs: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    // name of the props
    initial: _propTypes.default.any,
    // starting value
    setter: _propTypes.default.string,
    // name of the callback in the target component
    callbacks: _propTypes.default.arrayOf( // when you need something different than a simple setter
    _propTypes.default.shape({
      name: _propTypes.default.string,
      // Decides whether to pass the transformed value to the callback or just the value that
      // the base component passes.
      passTransformedValue: _propTypes.default.bool,
      transform: _propTypes.default.func // this function will be applied to the value and current state

    }))
  })),
  initialState: _propTypes.default.object,
  passedProps: _propTypes.default.object,
  mapToProps: _propTypes.default.func
});
(0, _defineProperty3.default)(StateContainer, "defaultProps", {
  stateDefs: [],
  initialState: {},
  passedProps: {},
  mapToProps: mapNothing
});

var inStateContainer = function inStateContainer(stateDefs, mapToProps) {
  return function (WrappedComponent) {
    return function (_ref7) {
      var initialState = _ref7.initialState,
          props = (0, _objectWithoutProperties2.default)(_ref7, ["initialState"]);
      return /*#__PURE__*/_react.default.createElement(StateContainer, {
        stateDefs: stateDefs,
        mapToProps: mapToProps,
        initialState: initialState,
        passedProps: props
      }, function (containerProps) {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, containerProps);
      });
    };
  };
};

exports.inStateContainer = inStateContainer;

var toggleTransform = function toggleTransform(value, current) {
  return !current;
};

exports.toggleTransform = toggleTransform;
var _default = StateContainer;
exports.default = _default;